import React from "react";

const DisplayMMDAssistantContext = React.createContext<boolean>(false);

export const DisplayMMDAssistantProvider = DisplayMMDAssistantContext.Provider;

export const useDisplayMMDAssistant = () => React.useContext(DisplayMMDAssistantContext);
